module.exports = __webpack_public_path__ + "img/dhl.d220437b.svg";